"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/*
 * Copyright 2018 Expedia, Inc. All rights reserved.
 * EXPEDIA PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
var _default = exports["default"] = {
  INVALID_MESSAGE: 'Data Protection: Invalid message',
  INVALID_MASK_PATTERN: 'Data Protection: Invalid mask pattern'
};